import { UserCommentAreaProps } from "types/userArea";
import { MODAL_COMMENT_TEXTAREA_MAX_LENGTH } from "utils/constants";
import { TextArea } from "components/common/TextArea.component";

export function UserCommentArea(props: UserCommentAreaProps) {
    return (
        <div className="w-100 pr-2">
            <div className="mb-4 text-default">
                {props.message}
            </div>
            <br />
            <div className="text-default">{props.inputMessage}</div>
            <TextArea
                id="workflow_user_comment_textarea"
                data-testid="workflow_user_comment_textarea"
                maxLength={MODAL_COMMENT_TEXTAREA_MAX_LENGTH}
                ref={props.userInput}
            />
            <div className={"text-secondary font-13"}>
                {props.moreInfo}
            </div>
        </div>

    );
}

export default UserCommentArea;